/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
} from '../../../apiClient'
import type {
  ListAsyncJobsQueryResponse,
  ListAsyncJobsQueryParams,
} from '../../types/ListAsyncJobs'
import type {
  QueryKey,
  QueryClient,
  QueryObserverOptions,
  UseQueryResult,
} from '@tanstack/react-query'
import { listAsyncJobs } from '../../clients/listAsyncJobs'
import { queryOptions, useQuery } from '@tanstack/react-query'

export const listAsyncJobsQueryKey = (params?: ListAsyncJobsQueryParams) =>
  [{ url: '/api/v1/async-jobs/' }, ...(params ? [params] : [])] as const

export type ListAsyncJobsQueryKey = ReturnType<typeof listAsyncJobsQueryKey>

export function listAsyncJobsQueryOptions(
  params?: ListAsyncJobsQueryParams,
  config: Partial<RequestConfig> & { client?: Client } = {}
) {
  const queryKey = listAsyncJobsQueryKey(params)
  return queryOptions<
    ListAsyncJobsQueryResponse,
    ResponseErrorConfig<Error>,
    ListAsyncJobsQueryResponse,
    typeof queryKey
  >({
    queryKey,
    queryFn: async ({ signal }) => {
      return listAsyncJobs(params, {
        ...config,
        signal: config.signal ?? signal,
      })
    },
  })
}

/**
 * @summary List async jobs for the current company
 * {@link /api/v1/async-jobs/}
 */
export function useListAsyncJobs<
  TData = ListAsyncJobsQueryResponse,
  TQueryData = ListAsyncJobsQueryResponse,
  TQueryKey extends QueryKey = ListAsyncJobsQueryKey,
>(
  params?: ListAsyncJobsQueryParams,
  options: {
    query?: Partial<
      QueryObserverOptions<
        ListAsyncJobsQueryResponse,
        ResponseErrorConfig<Error>,
        TData,
        TQueryData,
        TQueryKey
      >
    > & { client?: QueryClient }
    client?: Partial<RequestConfig> & { client?: Client }
  } = {}
) {
  const { query: queryConfig = {}, client: config = {} } = options ?? {}
  const { client: queryClient, ...resolvedOptions } = queryConfig
  const queryKey = resolvedOptions?.queryKey ?? listAsyncJobsQueryKey(params)

  const query = useQuery(
    {
      ...listAsyncJobsQueryOptions(params, config),
      ...resolvedOptions,
      queryKey,
    } as unknown as QueryObserverOptions,
    queryClient
  ) as UseQueryResult<TData, ResponseErrorConfig<Error>> & {
    queryKey: TQueryKey
  }

  query.queryKey = queryKey as TQueryKey

  return query
}
